import React, { Component } from "react";
import { connect } from "react-redux";
import CustomTable from "../../utils/commonComponent/CustomAntTable";
import { Col, Image, Row } from "react-bootstrap";
import editIcon from '../../assets/images/edit-icon.svg'

import deleteIcon from '../../assets/images/delete-icon.svg'

import editPencil from "../../assets/images/edit-icon.png";

// import CampingForm from "./CampingForm";
import { ComponentHeader, InformationModal, VerifiedModal } from "../common";
import { API_LIMIT, MODULE_ID_MAP, START_PAGE, isModuleExist } from "../../utils/Constant";
// import { deleteCampaignApi, getAllCampaignApi } from "./Api";

import { CAMPAGIN_VERIFY, MODAL_VERIFY } from "../../utils/urls";
import FilterVefiedDropDown from "../common/FilterVefiedDropDown";
import { getAllModalsDataApi } from "./Api";
import { withRouter } from "../../utils/hoc/withRouter";
import OptionsDropdown from "../../utils/commonComponent/OptionsDropdown";


export class Modals extends Component {
    constructor(props) {
        super(props);
        const AccesData = isModuleExist(MODULE_ID_MAP.ModalModal);
        this.state = {
            access: AccesData,
            dummyData: [],
            pageSize: API_LIMIT,
            currentPage: START_PAGE,
            languageList: [],
            totalPages: null,
            delete: false,
            deleteData: {},
            editData: "",
            showEdit: false,



            isVerify: false,
            show: false,

            verified: '',
            verifyUrl: ''
        };
    }

    // todo---------------------------------------
    componentDidMount() {
        const { history } = this.props;
        history({
            pathname: this.props.location.pathname,
            search: `?p=${this.state.currentPage || START_PAGE}`,
        });
        this.props.getAllModalsDataApi(this);
    }
    // todo---------------------------------------
    // todo:-----------------------------------------
    componentDidUpdate(prevProps, prevState) {
        const prevParams = new URLSearchParams(prevProps.location.search);
        const prevPage = parseInt(prevParams.get("page"), 10) || START_PAGE;
        const prevVerified = prevParams.get("isVerified") || "";
        const prevSize = parseInt(prevParams.get("pageSize"), 10) || API_LIMIT;

        const params = new URLSearchParams(this.props.location.search);
        const page = parseInt(params.get("page"), 10) || START_PAGE;
        // const search = params.get("search") || "";
        const size = parseInt(params.get("pageSize"), 10) || API_LIMIT;
        const verified = params.get("isVerified") || "";

        if (prevPage !== page || prevVerified !== verified || prevParams.get("search") !== params.get("search") || prevSize !== size) {
            this.setState({ currentPage: page }, () => {
                this.props.getAllModalsDataApi(this);

            });
        }
    }
    // todo:-----------------------------------------

    handleEdit = (rowData = null) => {
        this.props.history({ pathname: "edit-modal", state: { "data": rowData } });
    };
    openCloseDeleteModal = (rowData) => {
        this.setState({
            delete: !this.state.delete,
            deleteData: rowData,
        });
    };
    deleteHandle = async (id) => {


    }
    render() {
        const { showEdit, access } = this.state;
        const { modalData, totalPages, currentPage } = this.props.modalsState;

        return (
            <section className="request-section">


                <VerifiedModal
                    // name={`this '${this.state.editData?.campaignName}' campaign.`}
                    name={`'${this.state.editData?.title}'`}
                    show={this.state.show}
                    url={MODAL_VERIFY + `/${this.state?.editData?.uuid}`}
                    isVerified={this.state.isVerify}
                    handleCancel={() => { this.setState({ show: false }) }}
                    successRes={() => { this.props.getAllModalsDataApi(this) }}
                />

                <ComponentHeader
                    title="Modal"
                    isSearch={false}
                    placeholder={"Search Modal"}
                    onChangeMethod={this.onChangeMethod}
                    breadcrumb={[["Modals", "/modals"]]}
                    clearSearch={() => this.clearSearch()}
                // primaryBtn={access.createAccess ? "Add Modal" : ''}
                // handlePrimaryBtn={() => {
                //     // this.props.history('/ads/banner-ads/add');
                //     this.setState({ showEdit: true })
                // }}
                />
                {/* <Row>
                    <Col sm={2}>
                        <FilterVefiedDropDown ctx={this} />
                    </Col>
                </Row> */}
                <div className="commom-table-wrapper">

                    <CustomTable
                        data={modalData?.list || []}
                        columns={[

                            {
                                width: 350,
                                title: "Title",
                                dataIndex: "title",
                                className: "name",
                                isCell: true,
                                render: (text, rowData, dataKey) => {
                                    return rowData?.title;
                                },
                            },

                            // {
                            //     width: access.verificationAccess ? 100 : 0,
                            //     title: "Verified",
                            //     dataIndex: "verify",
                            //     className: "name",

                            //     isCell: true,
                            //     render:(text, rowData, dataKey) => {
                            //         if (dataKey === "verify") {
                            //             return <div className=" d-flex align-items-center inter-medium">
                            //                 {(rowData.isVerified) ? "Yes" : 'No'} <Image src={editPencil} onClick={() => this.setState({ show: true, isVerify: rowData.isVerified, editData: rowData })} className="edit-pencil-icon" alt="icon" />
                            //             </div>;
                            //         }
                            //     },
                            // },

                            {
                                width: 150,
                                title: "Sub Title",
                                dataIndex: "subTitle",
                                className: "name",
                                isCell: true,
                                render: (text, rowData, dataKey) => {
                                    return rowData?.subTitle || 'Na';
                                },
                            }, {
                                width: 150,
                                title: "Type",
                                dataIndex: "type",
                                className: "type",
                                isCell: true,
                                render: (text, rowData, dataKey) => {
                                    return rowData?.type || 'Na';
                                },
                            },
                            {
                                width: 150,
                                title: "Updated By",
                                dataIndex: "updatedBy",
                                className: "name",
                                isCell: true,
                                render: (text, rowData, dataKey) => {
                                    return rowData?.updatedBy?.name || 'Na';;
                                },
                            },
                            {
                                width: 150,
                                title: "Created By",
                                dataIndex: "createdBy",
                                className: "name",
                                isCell: true,
                                render: (text, rowData, dataKey) => {
                                    return rowData?.createdBy?.name || 'Na';
                                },
                            },

                            {
                                width: 20,
                                title: "Action",
                                dataIndex: "",
                                className: "",
                                isCell: true,
                                render: (text, rowData, dataKey) => {
                                    return (
                                        <>
                                            {/* {access.updateAccess && <Image src={editIcon} className="edit-icon" onClick={() => { this.handleEdit(rowData) }} />}
                                            {access.deleteAccess && <Image src={deleteIcon} className="edit-icon" onClick={() => { this.openCloseDeleteModal(rowData) }} />} */}
                                            <OptionsDropdown
                                                editHandler={access.updateAccess ? () => { this.handleEdit(rowData) } : null}
                                                
                                            />
                                        </>
                                    );
                                },
                            },
                        ]}

                        total={modalData?.length || 0}
                        loading={this.state.isLoading}
                    />
                </div>
            </section>
        );
    }
}

const mapStateToProps = (state) => ({
    modalsState: state.ModalsState,
});
const mapDispatchToProps = {
    getAllModalsDataApi,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Modals));
